import { SeoLinksZonesIds, SeoProject } from '@uno/common-shared';
export var EntityPrefixes;

(function (EntityPrefixes) {
  EntityPrefixes["ZONE"] = "ZONE";
  EntityPrefixes["TAGS"] = "TAGS";
  EntityPrefixes["SCORE"] = "SCORE";
})(EntityPrefixes || (EntityPrefixes = {}));

export var SeoLinkSchema = {
  type: 'object',
  properties: {
    linkOrder: {
      type: 'number'
    },
    author: {
      type: 'string'
    },
    imageSrc: {
      type: 'string'
    },
    lastActivityDate: {
      type: 'string'
    },
    title: {
      type: 'string'
    },
    url: {
      type: 'string'
    }
  },
  required: ['linkOrder', 'author', 'imageSrc', 'lastActivityDate', 'title', 'url'],
  additionalProperties: false
};
export var SeoLinksZoneEntitySchema = {
  type: 'object',
  properties: {
    modified: {
      type: 'string'
    },
    url: {
      type: 'string'
    },
    links: {
      type: 'array',
      items: SeoLinkSchema
    },
    zoneId: {
      type: 'number',
      "enum": Object.values(SeoLinksZonesIds)
    }
  },
  required: ['url', 'links', 'zoneId'],
  additionalProperties: false
};
export var HtmlTagsEntitySchema = {
  type: 'object',
  properties: {
    url: {
      type: 'string'
    },
    canonical: {
      type: 'string'
    },
    h1: {
      type: 'string'
    },
    mainKeyword: {
      type: 'string'
    },
    metadesc: {
      type: 'string'
    },
    noindex: {
      type: 'boolean'
    },
    title: {
      type: 'string'
    },
    redirectionUrl: {
      type: 'string'
    },
    killed: {
      type: 'boolean'
    }
  },
  required: ['url', 'canonical', 'h1', 'metadesc', 'noindex', 'title', 'redirectionUrl', 'killed'],
  additionalProperties: false
};
export var SeoScoreEntitySchema = {
  type: 'object',
  properties: {
    url: {
      type: 'string'
    },
    score: {
      type: 'number'
    },
    project: {
      "enum": Object.values(SeoProject)
    }
  },
  required: ['url', 'score', 'project'],
  additionalProperties: false
};